var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"margin-right":"0.6rem"}},[_c('span',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip",value:({
      trigger: 'hover',
      title: _vm.userName,
      boundary: 'window',
      container: 'usename_1',
    }),expression:"{\n      trigger: 'hover',\n      title: userName,\n      boundary: 'window',\n      container: 'usename_1',\n    }"}],attrs:{"id":"usename_1"},on:{"click":_vm.toMyProfile}},[_c('b-icon',{attrs:{"icon":"person-fill","font-scale":"1.5"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }